import { gql } from '@apollo/client';

export const VALIDATE_ZIP_WITH_STATE = gql`
  query validateZipWithState($zip: String!, $state: String!) {
    validateZipWithState(zip: $zip, state: $state) {
      isValid
      errors {
        code
        message
      }
    }
  }
`;

export const GET_CHECKOUT_DATA = gql`
  query getCheckoutData {
    getCheckoutData: getCheckoutData
  }
`;

export const GET_CART_SUMMARY = gql`
  query getCartSummary {
    cartSummary: getCartSummary {
      cart_subtotal
      cart_discount_total
      protection_plan
      errors {
        code
        field
        message
      }
    }
  }
`;
